module.exports = __webpack_public_path__ + "media/images/kipu-d01b76824764057b0183b171cf7eeb9a.svg";